import React from 'react';
import MegaMenu from '../MegaMenu/MegaMenu';
import clsx from 'clsx';

const NavigationLink = ({
  link,
  isActive,
  onLinkHover,
  onMouseLeaveLink,
  onMegaMenuClose,
  blocks,
  right = false,
}) => (
  <>
    <button
      className={clsx(
        'btn',
        'btn--medium',
        'border-0',
        'transition-colors',
        'hover:text-black',
        'hover:bg-white',
        isActive ? 'bg-white text-black' : 'text-white'
      )}
      onMouseOver={onLinkHover}
      onMouseLeave={onMouseLeaveLink}
    >
      {link.url ? (
        <a href={link.url}>{link.name}</a>
      ) : (
        <span>{link.name}</span>
      )}
    </button>
    {link.links?.length > 0 && (
      <MegaMenu
        onMegaMenuClose={onMegaMenuClose}
        onMouseLeaveMegaMenu={onMouseLeaveLink}
        onMouseOverMegaMenu={() => onLinkHover(link)}
        link={link}
        open={isActive}
        blocks={blocks}
      />
    )}
  </>
);

export default NavigationLink;
